import { Reveal } from "@components/ui";


const officeDetails = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
        <path
          d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="10" r="3" stroke="white" strokeWidth="1.5" />
      </svg>
    ),
    label: "Address",
    value: "Gaz Investment in Oil and Gas Supply L.L.C. (GAZ)",
    detail: "Dubai Investment Park 1, Dubai, United Arab Emirates",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
        <path
          d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    label: "Phone",
    value: "800-GAZ (42747)",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
        <path
          d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M22 6l-10 7L2 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Email",
    value: "help@gazglobal.net",
    isLink: true,
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="1.5" />
        <path d="M12 6v6l4 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Office Hours",
    value: "Sunday \u2013 Thursday: 8 AM \u2013 6 PM",
  },
];

export default function VisitOfficeSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal direction="up" className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold text-[#122d63] tracking-[-0.04em] font-albert-sans leading-tight">
            Visit Our Office
          </h2>
          <p className="text-[18px] md:text-[24px] lg:text-[28px] text-[#62636c] font-albert-sans mt-3 md:mt-4 tracking-[-0.02em]">
            We'd love to meet you in person.
          </p>
        </Reveal>

        {/* Two-column layout */}
        <div className="flex flex-col lg:flex-row gap-8 md:gap-10 lg:gap-12">
          {/* Left: Info Card */}
          <Reveal direction="left" className="flex-1 min-w-0">
            <div className="rounded-[24px] border border-[rgba(98,99,108,0.2)] bg-white overflow-hidden">
              {officeDetails.map((item, index) => (
                <div
                  key={item.label}
                  className={`flex items-start gap-4 md:gap-5 p-5 md:p-7 ${
                    index < officeDetails.length - 1 ? "border-b border-[rgba(98,99,108,0.15)]" : ""
                  }`}
                >
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-[12px] bg-[#122d63] flex items-center justify-center shrink-0">
                    {item.icon}
                  </div>
                  {/* Text */}
                  <div className="flex flex-col gap-1">
                    <span className="text-[16px] md:text-[20px] text-[#62636c] font-albert-sans">
                      {item.label}
                    </span>
                    <span
                      className={`text-[20px] md:text-[24px] lg:text-[28px] font-semibold text-[#090d2c] font-albert-sans leading-tight ${
                        item.isLink ? "underline decoration-1 underline-offset-4" : ""
                      }`}
                    >
                      {item.value}
                    </span>
                    {item.detail && (
                      <span className="text-[16px] md:text-[20px] text-[#62636c] font-albert-sans mt-1">
                        {item.detail}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Google Maps Button */}
            <Reveal direction="up" delay={200} className="mt-6 md:mt-8">
              <a
                href="https://maps.app.goo.gl/gcRMYqmMhyRyy956A"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#090d2c] text-white rounded-full py-3.5 pl-7 pr-3 font-albert-sans font-medium text-[16px] md:text-[18px] hover:bg-[#122d63] transition-colors duration-300"
              >
                Open in Google Maps
                <span className="w-10 h-10 rounded-full bg-[#f03813] flex items-center justify-center">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </a>
            </Reveal>
          </Reveal>

          {/* Right: Google Maps Embed */}
          <Reveal direction="right" className="flex-1 min-w-0">
            <div className="rounded-[16px] overflow-hidden aspect-square w-full">
              <iframe
                title="GAZ Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57860.361817563076!2d55.123863201467564!3d24.990851027896724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f72f4b0b690f1%3A0xbe838b0fd118f9d1!2sDubai%20Investment%20Park%20First%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sma!4v1772705254933!5m2!1sen!2sma"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
